"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// Shopify Forms customizations: label updates and style application
(function () {
  var sheet = new CSSStyleSheet();
  sheet.replaceSync("\n        :host button {\n            text-transform: uppercase!important;\n            font-family: var(--forms-heading-font);\n            font-weight: var(--font-heading-weight-black);\n            letter-spacing: .1rem;\n        }\n        :host {\n        --forms-body-font: var(--font-body-family);\n        --forms-heading-font: var(--font-heading-family);\n        }\n        :host h2 {\n            text-transform: uppercase;\n            font-family: var(--forms-heading-font);\n            font-weight: var(--font-heading-weight-black);\n        }\n    ");

  // Update form labels inside Shadow DOM
  function updateLabels() {
    var formEmbed = document.querySelector('shopify-forms-embed');
    if (formEmbed && formEmbed.shadowRoot) {
      var companyLabel = formEmbed.shadowRoot.getElementById('label-shipping_address_recipient');
      if (companyLabel) {
        companyLabel.textContent = 'Company';
      }
      var faoLabel = formEmbed.shadowRoot.getElementById('label-shipping_address_address2');
      if (faoLabel) {
        faoLabel.textContent = 'FAO';
      }
    }
  }

  // Apply styles to form-embed elements
  function styleForms() {
    document.querySelectorAll('form-embed').forEach(function (form) {
      if (form.shadowRoot && !form.shadowRoot.adoptedStyleSheets.includes(sheet)) {
        form.shadowRoot.adoptedStyleSheets = [].concat(_toConsumableArray(form.shadowRoot.adoptedStyleSheets), [sheet]);
      }
    });
  }

  // Single observer for both label updates and style application
  var observer = new MutationObserver(function () {
    updateLabels();
    styleForms();
  });

  // Initialize after DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    updateLabels();
    styleForms();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    var formContainer = document.querySelector('#app-embed');
    if (formContainer) formContainer.classList.add('loaded');

    // Smart interval: only run until labels are found, then stop
    var labelsFound = false;
    var fallbackInterval = setInterval(function () {
      updateLabels();
      var formEmbed = document.querySelector('shopify-forms-embed');
      if (formEmbed && formEmbed.shadowRoot) {
        var companyLabel = formEmbed.shadowRoot.getElementById('label-shipping_address_recipient');
        var faoLabel = formEmbed.shadowRoot.getElementById('label-shipping_address_address2');
        if (companyLabel && faoLabel && companyLabel.textContent === 'Company' && faoLabel.textContent === 'FAO') {
          labelsFound = true;
          clearInterval(fallbackInterval); // Stop interval once labels are updated
        }
      }
    }, 500);

    // Clear interval after 10 seconds regardless (failsafe)
    setTimeout(function () {
      return clearInterval(fallbackInterval);
    }, 10000);
  });
})();